'use strict';

var SearchSummaryDirective = function SearchSummaryDirective() {
  return {
    restrict: 'E',
    controller: 'SearchSummaryController',
    template: require('../templates/search-summary.html'),
    scope: {
      screen: '@'
    },
    link: function link($scope) {
      $scope.$on('search-criteria:searchChangeEvent', $scope.onSearchChange);
      $scope.$on('search-criteria:leftOperandChanged', $scope.onSearchChange);
    }
  };
};
SearchSummaryDirective.$inject = [];
module.exports = SearchSummaryDirective;